<template>
  <v-card
    class="mx-auto mb-5"
    :class="{ isReviewed: isReviewed == true }"
    elevation="15"
    min-height="170"
    :dark="isReviewed"
    max-width="200"
  >
    <v-card-text class="text-center">
      <v-avatar color="grey" size="140" tile>
        <v-img v-if="this.videoThumb" :src="this.videoThumb" />
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <!-- <v-img
          v-else
          src="https://images.pexels.com/photos/3779760/pexels-photo-3779760.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=200&w=300"
        /> -->
      </v-avatar>

      <v-rating
        v-if="isReviewed"
        v-model="applicant.rating"
        background-color="yellow darken-3"
        color="orange"
        half-increments
        readonly
        small
      ></v-rating>
    </v-card-text>
    <v-card-actions class="pt-0" v-if="!isReviewed">
      <v-btn
        @click="handleApplicantClick(applicant)"
        text
        color="deep-purple accent-4"
        class="caption"
        >View {{ applicant.user.firstName }}'s Video</v-btn
      >
    </v-card-actions>

    <v-card-actions class="pt-0 justify-space-between" v-else>
      <v-btn text color="#fff" class="caption"
        >{{ applicant.user.firstName }} - Viewed</v-btn
      >
      <v-icon>mdi-check-circle</v-icon>
    </v-card-actions>
  </v-card>
</template>

<script>
//import axios from 'axios';
export default {
  props: [
    'id',
    'handleApplicantClick',
    'rating',
    'is-reviewed',
    'candidate',
    'queuedApplicants',
    'applicant',
  ],
  data() {
    return {
      videoThumb: this.videoThumb,
    };
  },
  created() {
    //check video thumbnail

    const self = this;
    console.log(self.applicant);
    if (!self.applicant.videoThumb) {
      console.log('no video thumb');

      let Vimeo = require('vimeo').Vimeo;
      let client = new Vimeo(
        '757d27075fbb47670d8e45a767f6c2ce7b050279',
        'FAmshigr/NFiWUjSw1Hi/etD4b7Lflh318tHkR7RiTGT3rVhna7V5vkU60I/nXO+CK5fhDzdYTb/7BTyKh7VERJ6NmQX7VHfMsl1Y3DzgT2oFa5eAiEEjPHXq2L/goS4',
        '9ea71d9d177393d7954e1a5a725b070c'
      );

      client.request(
        {
          method: 'GET',
          path: `videos/${self.applicant.video}`,
        },
        function (error, body) {
          if (error) {
            console.log(error);
          }

          self.videoThumb = body.pictures.sizes[1].link;
          // axios.put(
          //   process.env.VUE_APP_REST_HTTP
          //     ? `${process.env.VUE_APP_REST_HTTP}/candidates/${self.getUserData.candidate.id}`
          //     : `http://localhost:1337/candidates/${self.getUserData.candidate.id}`,
          //   {
          //     videoThumb: body.pictures.sizes[1].link,
          //   }
          // );
        }
      );
    }
  },
  // mounted() {
  //   this.handleApplicantClick();
  // },
};
</script>

<style>
/* .isReviewed {
  opacity: 0.5;
} */
/* .isReviewed.v-card {
  background-color: #4caf50;
  background-color: rgba(76, 175, 80, 0.6);
} */
</style>
